const optionItemClasses =
    "cursor-pointer px-3 py-1.5 [margin:0_-12px] rounded-md block " +
    "transition-[background-color,color] duration-200 ease-out " +
    "hover:bg-primary-surface hover:text-primary hover:font-medium";

const optionItemLastClasses = "mb-3";

// Renders a single row inside the DownloadOptions menu
const DownloadOption = ({ label, onClick, isLast = false }) => (
    <div
        className={`${optionItemClasses} ${isLast ? optionItemLastClasses : ''}`}
        onClick={onClick}
    >
        {label}
    </div>
);

export default DownloadOption;
